// DS: DEV5
import React from 'react';
import c from 'classnames';
import { Popper, PopperManager } from '../Popover';
import s from './NewIndicatorDot.scss';
export var NewIndicatorDot = function (_a) {
    var className = _a.className, contentClassName = _a.contentClassName, tooltipMessage = _a.tooltipMessage, tooltipForceTheme = _a.tooltipForceTheme;
    return (React.createElement("div", { className: className }, tooltipMessage ? (React.createElement(PopperManager, { renderReference: function (_a) {
            var ref = _a.ref;
            return React.createElement("div", { ref: ref, className: s['dot'] });
        } },
        React.createElement(Popper, { forceTheme: tooltipForceTheme, placement: "right", modifiers: {
                offset: {
                    offset: '2, 8',
                },
            }, contentClassName: c(s['tooltip-content'], contentClassName) }, tooltipMessage))) : (React.createElement("div", { className: s['dot'] }))));
};
NewIndicatorDot.displayName = 'NewIndicatorDot';
export default NewIndicatorDot;
//# sourceMappingURL=NewIndicatorDot.js.map